/**
* @description: 队长管理
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox" v-if="state.flag">
            <hc-search :data="searchData" @serch="getSearch">
                <template #btns>
                    <el-button type="primary" icon="Plus" @click="adduser?.open()">{{ t('common.add') }}</el-button>
                </template>
            </hc-search>
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :loading="state.loading" :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
                :maxPage="maxPage" @pageChange="pageChange" @limitChange="limitChange">
                <template #employment="{ row }">
                    {{ listToMap(employmentOptions, {})[row.employment] }}
                </template>
                <template #login_time="{ row }">
                    {{ formatDisplayDateTime(row.login_time) || '-' }}
                </template>
                <template #start_date="{ row }">
					{{ formatDisplayDate(row.start_date) || '-' }}
				</template>
                <template #end_date="{ row }">
					{{ formatDisplayDate(row.end_date) || '-' }}
				</template>
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="toDetail(scope.row)">{{ t('personnelList.linkMachinist') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>

        <BindUser ref="bindUser" :title="t('personnelList.linkMachinist')" @refresh="getSearch(searchData)" />
        <rg-user
            ref="adduser"
            :title="t('personnelList.editCaptain')"
            :add-title="t('personnelList.addCaptain')"
            :default-role-id="2"
            :lock-role="true"
            :statusOptions="statusOptions"
            :roleOptions="roleFormOptions"
            :sexOptions="sexOptions"
            @refresh="getSearch(searchData)"
        />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, toRaw, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import rgUser from "../system/components/userAdd.vue";
import BindUser from "./components/bindUser.vue";

import { pageListApi, resetPwd, saveApi } from "@/api/system/personnel";
import { listToMap } from "@/utils/utils";
import { formatDisplayDate, formatDisplayDateTime } from "@/utils/dateTime.js";
import { ElMessage } from "element-plus";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyPersonnelListLabels } from "@/utils/personnelListI18n.js";

const myElementRef = ref();
const searchBox = ref();
const router = useRouter();
const route = useRoute();
const adduser = ref();
const bindUser = ref();

let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const statusOptions = reactive([
    { label: "禁用", value: 0 },
    { label: "启用", value: 1 }
])

const employmentOptions = reactive([
    { label: "在职", value: 1 },
    { label: "离职", value: 0 },
])

const sexOptions = reactive([
    { label: "未知", value: 0 },
    { label: "男", value: 1 },
    { label: "女", value: 2 }
])

const roleOptions = reactive([
    { label: "全部", value: 0 },
    { label: "机手", value: 1 },
    { label: "队长", value: 2 },
])

const roleFormOptions = computed(() => roleOptions.filter((r) => r.value === 2))

const searchData = reactive([
    {
        label: "队长信息",
        type: "input",
        value: "",
        placeholder: "姓名/用户名/手机号/邮箱",
        field: 'keywords',
    },
]);

const state = reactive({
    title: "",
    loading: false,
    column: [
        {
            prop: "id",
            show: true,
            label: "队长ID",
            width: 90,
        },
        {
            // prop: "id",
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "real_name",
            show: true,
            label: "姓名",
            width: 100
        },
        {
            prop: "english_name",
            show: true,
            label: "英文名",
            width: 100
        },
        {
            prop: "id_card",
            show: true,
            label: "身份号码",
            width: 160
        },
        {
            prop: "sex",
            show: true,
            label: "性别",
            width: 80
        },
        {
            prop: "username",
            show: true,
            label: "用户名",
            width: 120
        },
        {
            prop: "password",
            show: true,
            label: "密码",
            width: 160
        },
        {
            prop: "email",
            show: true,
            label: "邮箱",
            width: 180
        },

        {
            prop: "address",
            show: true,
            label: "家庭住址",
            width: 200
        },
         {
            prop: "start_date",
            show: true,
            label: "入职时间",
            width: 160
        },
         {
            prop: "end_date",
            show: true,
            label: "离职时间",
            width: 160
        },
        {
            prop: "employment",
            show: true,
            label: "在职状态",
            width: 100
        },
        {
            prop: "mobile",
            show: true,
            label: "手机",
            width: 160
        },
        {
            prop: "points",
            show: true,
            label: "分数",
            width: 80
        },
        {
            prop: "status",
            show: true,
            label: "状态",
            width: 80
        },
        {
            prop: "login_time",
            show: true,
            label: "最近登录时间",
            width: 160
        },
        // {
        //     prop: "updated_at",
        //     show: true,
        //     label: "更新时间",
        //     width: 160
        // },
        {
            prop: "operation",
            show: true,
            label: "操作",
            width: 100
        },
    ],
    flag: true,
    offsetHeight: 0,
    tableHeader: [],
    tableData: [
        // {
        //   "password": "123456",
        //   "updated_at": "2025-05-07 14:21:31",
        //   "role_id": listToMap(roleOptions)[1],
        //   "sex": listToMap(sexOptions)[1],
        //   "mobile": "13456214521",
        //   "created_at": "2025-05-07 14:21:31",
        //   "real_name": "张三",
        //   "id": 1,
        //   "email": "14253658@qq.com",
        //   "username": "jishou0001",
        //   "points": 0,
        //   "status": listToMap(statusOptions)[1],
        // }
    ]
});

const applyLabels = () => {
    applyPersonnelListLabels({
        searchData,
        columns: state.column,
        employmentOptions,
        sexOptions,
        statusOptions,
        role: "captain",
    });
};
const { t } = usePageI18n(applyLabels);

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const initPwd = (row) => {
    const params = JSON.stringify({
        id: row.id
    })
    resetPwd(params).then(res => {
        if (res?.code === 200) {
            ElMessage.success('操作成功');
        }
    })
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData);
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData);
}

// 查询列表数据
const getSearch = (params = []) => {
    state.loading = true
    const form = listToMap(toRaw(params), { value: 'value', key: 'field' })
    const requestParams = {
        page: page.value,
        limit: limit.value,
        ...form,
        role_id: 2
    }
    pageListApi(JSON.stringify(requestParams)).then(res => {
        maxPage.value = res?.maxPage ?? 0;
        state.tableData = res?.data?.map(item => {
            return {
                ...item,
                // role_id: listToMap(roleOptions, {})[item.role_id],
                sex: listToMap(sexOptions, {})[item.sex],
                status: listToMap(statusOptions, {})[item.status],
            }
        }) ?? []
        state.loading = false
    }).catch(e => {
        maxPage.value = 0
        state.tableData = []
        state.loading = false
    })
};

const toDetail = (row) => {
    router.push({
        path: '/captain-detail',
        query: {
            id: row.id
        }
    })
}

onMounted(() => {
    try {
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        applyLabels();
        tableHeaderFn();
        getSearch(searchData);
    } catch (e) {
    }
});

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

onUnmounted(() => {
    window.onresize = null;
});
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    // margin: 0 !important;
    margin: 0 0 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
